@if(!multiRangeSliderInputs) {
<span>{{ minLabel }}</span>
}
<div class="position-relative flex-grow-1 mx-2 range-wrapper">
  @if(!multiRangeSliderInputs) {
  <div class="range-tooltip-wrapper">
    <div class="min" #tooltipLow>
      <span class="inner-tooltip">{{ rangeMinLabel }}</span>
    </div>
    <div class="max" #tooltipHigh>
      <span class="inner-tooltip">{{ rangeMaxLabel }}</span>
    </div>
  </div>
  }
  <div class="range-input-wrapper">
    <div
      class="range-input-progress"
      [ngClass]="{ disabled: disabled }"
      #progress
    ></div>
    @if (this.value) {
    <input
      type="range"
      class="range-input range-input-min"
      (input)="this.onDrag($event, true)"
      (mouseup)="this.emitRange()"
      (touchend)="this.emitRange()"
      [step]="step"
      [min]="min"
      [max]="maxDisplayed"
      [(ngModel)]="this.value.min"
      [disabled]="disabled"
    />
    <input
      type="range"
      class="range-input range-input-max"
      (input)="this.onDrag($event, false)"
      (mouseup)="this.emitRange()"
      (touchend)="this.emitRange()"
      [step]="step"
      [min]="min"
      [max]="maxDisplayed"
      [(ngModel)]="this.value.max"
      [disabled]="disabled"
    />
    }
  </div>

  @if(multiRangeSliderInputs) {
  <section class="range-form-holder d-flex mt-3" [formGroup]="rangeSliderForm">
    <div>
      <label
        for="minimumInput"
        class="d-block small text-muted"
        i18n="RangeSlider@@rangeSliderMinimumLabel"
        >Minimum:</label
      >
      <div class="input-holder d-flex align-items-center">
        <input
          #minimumInput
          class="form-control"
          type="text"
          atxNumberInput
          inputmode="numeric"
          [placeholder]="min"
          formControlName="minimum"
        />
        @if(unit?.length) {
        <span>{{ unit }}</span>
        }
      </div>
    </div>
    <div class="ml-auto">
      <label
        for="minimumInput"
        class="d-block small text-muted"
        i18n="RangeSlider@@rangeSliderMaximumLabel"
        >Maximum:</label
      >
      <div class="input-holder d-flex align-items-center">
        <input
          class="form-control"
          type="text"
          atxNumberInput
          inputmode="numeric"
          [placeholder]="maxDisplayed"
          formControlName="maximum"
        />
        @if(unit?.length) {
        <span>{{ unit }}</span>
        }
      </div>
    </div>
  </section>
  }
</div>
@if(!multiRangeSliderInputs) {
<span>{{ maxLabel }}</span>
}
